import { adobeAnalyticsScriptsSelector } from '../../../redux/features/analytics';
import { AppDispatch, AppGetState } from '../../../redux/store';
import { tlReadyExecute } from '../../../utils/adobeAnalyticsUtil';

/**
 * 絞り込みボタンクリック計測
 * @param event
 * @returns クリック計測
 */
export const measureNarrowDownButtonClick =
  (event) => (dispatch: AppDispatch, getState: AppGetState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    const buttonId: string = event.target.id;
    const linkName = `click_siborikomi_area_shokushu_${buttonId}`;

    tlReadyExecute(isAdobeScript, dispatch, linkName, {});
  };
